<template>
  <ul :class="[$style.wrap, $style[`wrap-${activeTab}`]]">
    <li v-for="i in 2" :key="i" :class="i === activeTab && $style.current">
      <button
        :disabled="i === activeTab"
        :class="i === activeTab && $style.current"
        @click="onClick(i)"
      />
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OverviewNav",
  computed: {
    ...mapGetters(["activeTab"])
  },
  methods: {
    ...mapActions(["setActiveTab"]),
    onClick(index) {
      this.setActiveTab(index);
      this.$emit("change");
    }
  }
};
</script>

<style lang="less" module>
@activeCount: 2;
@activeWidth: 400;
@activeHeight: 80;

.wrap {
  .background-fill("./images/nav-bg.png");

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  width: @base-width-rem;
  height: 1.75rem;
  margin: 0 auto;
  padding-top: 0.66rem;

  li {
    flex-shrink: 0;

    .size(@activeWidth * 0.01rem, @activeHeight * 0.01rem);

    .loop(@n) when (@n < @activeCount + 1) {
      &:nth-child(@{n}) button {
        .sprites-position-x(
          @activeHeight * @activeCount,
          @activeHeight,
          @activeHeight * (@n - 1)
        );

        &.current {
          .sprites-position-x(
            @activeHeight * @activeCount,
            @activeHeight,
            @activeHeight * (@n - 1),
            100%
          );
        }
      }
      .loop(@n+1);
    }
    .loop(1);
  }

  button {
    .size(100%);
    .background-fill("./images/nav-menu.png", 200% 200%);
  }
}
</style>
